import axios, { AxiosError } from "axios";
import {storageSetItem, storageRemoveItem} from "lib/storage";
import store from "lib/store";

import API from "api/api";
import {
  login, logout, sessionExpire, setLoginErr, clrLoginErr,
} from "reducers/appstate";
import {
  setCidDefault, clrCidDefault,
  setTagDefault, clrTagDefault,
} from "reducers/appstate_act"
import {
  setSchoolInfo, clrSchoolInfo, errSchoolInfo,
} from "reducers/schoolinfo";

import ALoginAPI, { ALoginAPIPostResponse } from "api/admin/a_login_api";


interface LoginArgument {
  idkind: string;
  loginid: string;
  password: string;
  siteName: string;
}




/**
 * AdminAPI
 */
class AdminAPI {
  static init() {
    // API エラーハンドラを登録
    axios.interceptors.response.use(
      (response) => response,
      (error) => AdminAPI.handleAPIError(error)
    );

    API.init();
  }


  /**
   * APIエラーハンドリング処理
   */
  static handleAPIError(error: AxiosError) {
    // 認証エラー
    if (error?.response?.status === 401) {
      // ログイン済み？
      if (store.getState().appState.isLogin === true) {
        // セッション切れを通知
        store.dispatch(sessionExpire());

        // キャンセルを通知
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }


  /**
   * ログインを実行
   * @param data API呼び出し引数
   * @param signal AbortSignal
   * @returns Promise<> ログイン失敗時はrejectされる
   */
  static async login(data: LoginArgument, signal?: AbortSignal) {
    let apiResult;

    // ログインエラー状態をクリア
    store.dispatch(clrLoginErr());

    try {
      apiResult = await ALoginAPI.post(
        {
          ...data,
          debugMode: 0,
        },
        signal
      );
    }
    catch (e: unknown) {
      store.dispatch(setLoginErr());
      store.dispatch(errSchoolInfo());

      throw e;
    }

    AdminAPI.loginSuccess(apiResult);
  }


  /**
   * ログアウト
   * @description 本関数を呼び出すとログアウトされ、情報がクリアされる
   */
  static logout(shouldReload = true) {
    // 無限ログアウトが発生するため、ログインしている場合のみログアウト処理を実行
    if (store.getState().appState.isLogin === true) {
      storageRemoveItem("session");
      store.dispatch(clrCidDefault());
      store.dispatch(clrTagDefault());

      if (shouldReload) {
        window.location.reload();
      }
      else
      {
        // Window Reloadを実行しない場合に実行する
        store.dispatch(clrSchoolInfo());
        store.dispatch(logout());
      }
    }
  }


  /**
   * ログイン成功
   * @param {Object} apiResult login api result 
   * @description 通常ログインとセッションリストア時のログイン処理があるので共通処理を関数化している
   */
  static loginSuccess(apiResult: ALoginAPIPostResponse) {
    store.dispatch(login(apiResult.session, apiResult.userInfo));
    store.dispatch(setCidDefault(apiResult.userInfo.staff.cid));
    store.dispatch(setTagDefault(""));
    store.dispatch(setSchoolInfo(apiResult.schoolInfo));

    // Store session storage
    storageSetItem("session", apiResult.session);
  }
}

export {
  AdminAPI as default,
  AdminAPI
};
